import { LocalStorageKeys } from '../LocalStorageKeys';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

export const appLanguages = {
  en: 'English',
  tg: 'Telugu',
  tm: 'Tamil',
  es: 'Spanish',
};

export enum Langs {
  EN = 'en',
  ES = 'es',
  TM = 'tm',
  TG = 'tg',
}

const defaultWatchLang = Langs.EN;
const defaultDisplayLang = Langs.EN;

/**
 * Getting the users current watch language
 *
 * @param language
 * @returns English / Spanish
 */

export const getLanguageValue = (language: string): string => {
  return language === Langs.ES ? appLanguages[Langs.ES] : appLanguages[Langs.EN];
};

/**
 * Get Lang from local storage or default value
 *
 * @returns en / es
 */
export const getSelectedDisplayLang = (localStorage: LocalStorageService) => {
  return localStorage.getItem(LocalStorageKeys.LANG) ? localStorage.getItem(LocalStorageKeys.LANG) : defaultDisplayLang;
};

/**
 * Get watch lang from local storage or default value
 *
 * @returns en / es
 */
export const getSelectedWatchLang = (localStorage: LocalStorageService) => {
  return localStorage.getItem(LocalStorageKeys.WATCH_LANG) ? localStorage.getItem(LocalStorageKeys.WATCH_LANG) : defaultWatchLang;
};

/**
 * Get language name from local storage
 *
 * @returns English / Spanish
 */
export const getSelectedDisplayLangName = (localStorage: LocalStorageService): any => {
  return localStorage.getItem(LocalStorageKeys.LANG) === Langs.ES ? appLanguages[Langs.ES] : appLanguages[Langs.EN];
};

/**
 * Get watch language name from local storage
 *
 * @returns English / Spanish
 */
export const getSelectedWatchLangName = (localStorage: LocalStorageService): any => {
  return localStorage.getItem(LocalStorageKeys.WATCH_LANG) === Langs.ES ? appLanguages[Langs.ES] : appLanguages[Langs.EN];
};